import { createContext, useContext } from 'react';

export type SelectContextValue = {
  /** Current controlled value of the select. */
  value: string;
  /** Clears the selection by calling `onValueChange('')`. */
  clearValue: () => void;
};

const SelectContext = createContext<SelectContextValue | undefined>(undefined);

export const SelectProvider = SelectContext.Provider;

/**
 * Returns undefined when outside provider.
 * Useful for SelectTrigger to gracefully fall back to prop-only behavior.
 */
export const useSelectContextOptional = () => useContext(SelectContext);
